import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CartNotFound from "./CartNotFound";
import { userStore } from "../../store/userStore";
import { getApiUrl } from "../../config/api";

const ShoppingCart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const userid = userStore((state) => state._id);
  
  console.log("🛒 SIMPLE Cart page loaded - userid:", userid);
  console.log("🛒 SIMPLE Cart page loaded - cartItems:", cartItems);
  console.log("🛒 SIMPLE localStorage user-storage:", localStorage.getItem("user-storage"));
  console.log("🛒 SIMPLE localStorage cart:", localStorage.getItem("cart"));

  // Simple cart loading - no context dependency
  useEffect(() => {
    console.log("🛒 SIMPLE: useEffect triggered - userid:", userid);
    console.log("🛒 SIMPLE: Component mounted, starting cart load");
    
    const loadCart = async () => {
      console.log("🛒 SIMPLE: Starting cart load for user:", userid);
      setIsLoading(true);
      setError(null);
      
      try {
        // Try to get user ID from multiple sources
        let currentUserId = userid;
        
        // If no user ID from store, try to get from localStorage directly
        if (!currentUserId) {
          console.log("🛒 SIMPLE: No user ID from store, checking localStorage directly");
          const userStorage = localStorage.getItem("user-storage");
          if (userStorage) {
            try {
              const userData = JSON.parse(userStorage);
              currentUserId = userData.state?._id;
              console.log("🛒 SIMPLE: Found user ID in localStorage:", currentUserId);
            } catch (error) {
              console.error("🛒 SIMPLE: Error parsing user storage:", error);
            }
          }
        }
        
        if (currentUserId) {
          console.log("🛒 SIMPLE: Making direct API call to:", getApiUrl(`/cart/${currentUserId}`));
          const response = await fetch(getApiUrl(`/cart/${currentUserId}`));
          
          if (response.ok) {
            const data = await response.json();
            console.log("🛒 SIMPLE: API response:", data);
            
            if (data?.items && data.items.length > 0) {
              const items = data.items.map((item) => ({
                _id: item.product._id,
                name: item.product.name,
                quantity: item.quantity,
                realTimeTotalPrice: item.realTimeTotalPrice,
                coverImage: item.product.coverImage,
                ...item.product
              }));
              
              console.log("🛒 SIMPLE: Processed cart items:", items);
              setCartItems(items);
            } else {
              console.log("🛒 SIMPLE: No items in cart");
              setCartItems([]);
            }
          } else {
            console.error("🛒 SIMPLE: API error:", response.status, response.statusText);
            setError("Failed to load cart");
          }
        } else {
          console.log("🛒 SIMPLE: No user ID found anywhere, trying hardcoded user ID");
          // Try with hardcoded user ID as last resort
          try {
            const hardcodedUserId = "68ded148cbfe892dc87f3c45";
            console.log("🛒 SIMPLE: Trying with hardcoded user ID:", hardcodedUserId);
            const response = await fetch(getApiUrl(`/cart/${hardcodedUserId}`));
            
            if (response.ok) {
              const data = await response.json();
              console.log("🛒 SIMPLE: Hardcoded API response:", data);
              
              if (data?.items && data.items.length > 0) {
                const items = data.items.map((item) => ({
                  _id: item.product._id,
                  name: item.product.name,
                  quantity: item.quantity,
                  realTimeTotalPrice: item.realTimeTotalPrice,
                  coverImage: item.product.coverImage,
                  ...item.product
                }));
                
                console.log("🛒 SIMPLE: Hardcoded processed items:", items);
                setCartItems(items);
              } else {
                console.log("🛒 SIMPLE: No items in hardcoded response");
                setCartItems([]);
              }
            } else {
              console.log("🛒 SIMPLE: Hardcoded API failed, checking localStorage");
              const localCart = localStorage.getItem("cart");
              if (localCart) {
                const parsedCart = JSON.parse(localCart);
                console.log("🛒 SIMPLE: Loading from localStorage:", parsedCart);
                setCartItems(parsedCart);
              } else {
                console.log("🛒 SIMPLE: No cart data found anywhere");
                setCartItems([]);
              }
            }
          } catch (error) {
            console.error("🛒 SIMPLE: Hardcoded API error:", error);
            setCartItems([]);
          }
        }
      } catch (error) {
        console.error("🛒 SIMPLE: Error loading cart:", error);
        setError("Error loading cart");
      } finally {
        setIsLoading(false);
      }
    };

    // Add a small delay to ensure localStorage is available
    setTimeout(loadCart, 100);
  }, [userid]);

  const handleQuantityChange = async (id, increment) => {
    const item = cartItems.find((item) => item._id === id);
    if (!item) return;

    const newQuantity = item.quantity + increment;

    if (newQuantity <= 0) {
      // Remove item completely
      try {
        const response = await fetch(getApiUrl('/cart/remove-from-cart'), {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userId: userid, productId: id })
        });
        if (response.ok) {
          setCartItems(prev => prev.filter(item => item._id !== id));
        }
      } catch (error) {
        console.error('Error removing item:', error);
      }
    } else {
      // Update quantity
      try {
        const response = await fetch(getApiUrl('/cart/add-to-cart'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userId: userid, productId: id, quantity: increment })
        });
        if (response.ok) {
          // Reload cart
              const cartResponse = await fetch(getApiUrl(`/cart/${userid}`));
          if (cartResponse.ok) {
            const cartData = await cartResponse.json();
            if (cartData?.items) {
              const items = cartData.items.map((item) => ({
                _id: item.product._id,
                name: item.product.name,
                quantity: item.quantity,
                realTimeTotalPrice: item.realTimeTotalPrice,
                coverImage: item.product.coverImage,
                ...item.product
              }));
              setCartItems(items);
            }
          }
        }
      } catch (error) {
        console.error('Error updating quantity:', error);
      }
    }
  };

  // This function is preserved, but the remove button is no longer rendered
  // const handleRemoveItem = async (id) => {
  //   removeFromCart({ userId: userid, productId: id });
  //   getCart(userid); // refresh after removal
  // };
  const getSubtotal = () => {
    return cartItems.reduce((total, item) => {
      const price = Number(item.realTimeTotalPrice) || 0;
      return total + price;
    }, 0);
  };

  const calculateTotals = () => {
    const subtotal = getSubtotal();
    const tax = Math.round(subtotal * 0.03);
    const shipping = subtotal > 5000 ? 0 : 50;
    const discount = 0;
    const total = subtotal + tax + shipping - discount;

    return {
      subtotal,
      tax,
      shipping,
      discount,
      total,
    };
  };

  const totals = calculateTotals();

  // Debug logging
  console.log("🛒 SIMPLE: Cart length:", cartItems.length);
  console.log("🛒 SIMPLE: Cart items:", cartItems);
  console.log("🛒 SIMPLE: Loading:", isLoading);
  console.log("🛒 SIMPLE: Error:", error);

  // Show loading state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading your cart...</p>
        </div>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600 mb-4">Error: {error}</p>
          <button 
            onClick={() => window.location.reload()} 
            className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // Show empty cart
  if (cartItems.length === 0) {
    return <CartNotFound />;
  }

  return (
    <div className="bg-[#FAF7F2] min-h-screen px-4 sm:px-6 lg:px-10 py-10 space-y-10">
      {/* Debug Panel */}
      <div className="p-4 bg-yellow-100 border border-yellow-300 rounded-lg">
        <h3 className="font-bold text-yellow-800 mb-2">Debug Info:</h3>
        <p><strong>User ID:</strong> {userid || 'Not found'}</p>
        <p><strong>Cart Items:</strong> {cartItems.length}</p>
        <p><strong>Loading:</strong> {isLoading ? 'Yes' : 'No'}</p>
        <p><strong>Error:</strong> {error || 'None'}</p>
        <button 
          onClick={() => window.location.reload()} 
          className="mt-2 px-3 py-1 bg-yellow-500 text-white rounded text-sm mr-2"
        >
          Refresh Page
        </button>
        <button 
          onClick={async () => {
            console.log("🧪 Manual test: Loading cart with hardcoded user ID");
            try {
              const response = await fetch(getApiUrl('/cart/68ded148cbfe892dc87f3c45'));
              const data = await response.json();
              console.log("🧪 Manual test response:", data);
              if (data?.items) {
                const items = data.items.map((item) => ({
                  _id: item.product._id,
                  name: item.product.name,
                  quantity: item.quantity,
                  realTimeTotalPrice: item.realTimeTotalPrice,
                  coverImage: item.product.coverImage,
                  ...item.product
                }));
                setCartItems(items);
                console.log("🧪 Manual test: Set cart items:", items);
              }
            } catch (error) {
              console.error("🧪 Manual test error:", error);
            }
          }}
          className="mt-2 px-3 py-1 bg-blue-500 text-white rounded text-sm mr-2"
        >
          Test Load Cart
        </button>
        <button 
          onClick={() => {
            console.log("🔄 Force reload: Triggering useEffect");
            window.location.reload();
          }}
          className="mt-2 px-3 py-1 bg-green-500 text-white rounded text-sm"
        >
          Force Reload
        </button>
      </div>
      
      <div className="p-6 bg-white shadow-md w-full">
        <h1 className="text-2xl font-bold mb-6">Shopping Cart</h1>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead className="bg-[#784421] text-white">
              <tr>
                <th className="py-3 px-4">Product</th>
                <th className="py-3 px-4">Price</th>
                <th className="py-3 px-4">Quantity</th>
                <th className="py-3 px-4">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {cartItems?.map((item, index) => (
                <tr key={index} className="border-b">
                  <td className="py-3 px-4 flex items-center space-x-4">
                    <img
                      src={
                        item.images?.[0] ||
                        item.coverImage ||
                        "https://via.placeholder.com/50"
                      }
                      alt={item.name}
                      className="w-16 h-16 object-cover"
                    />
                    <span className="truncate font-semibold">{item.name}</span>
                  </td>
                  <td className="py-3 px-4">
                    ₹{item.realTimeTotalPrice / item.quantity}
                  </td>
                  <td className="py-3 px-4">
                    <div className="flex items-center border w-fit rounded-full overflow-hidden">
                      <button
                        onClick={() => handleQuantityChange(item._id, -1)}
                        className="px-3 py-1 bg-gray-200"
                        // disabled={item.quantity === 1}
                      >
                        -
                      </button>
                      <span className="px-4 text-lg">{item.quantity}</span>
                      <button
                        onClick={() => handleQuantityChange(item._id, 1)}
                        className="px-3 py-1 bg-gray-200"
                      >
                        +
                      </button>
                    </div>
                  </td>
                  <td className="py-3 px-4">₹{item.realTimeTotalPrice}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center w-full mt-6 gap-4">
          <div className="flex w-full sm:w-1/2 items-center">
            <input
              type="text"
              placeholder="Coupon Code"
              className="border border-gray-500 outline-none p-2 w-full"
            />
            <button className="bg-[#D87F30] text-white px-6 py-2 ml-2">
              APPLY
            </button>
          </div>
          <Link
            to="/productlist"
            className="text-center text-black text-lg underline"
          >
            Continue Shopping
          </Link>
          <button className="bg-[#D87F30] text-white px-6 py-2 w-full sm:w-auto">
            UPDATE CART
          </button>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row-reverse lg:justify-between gap-6">
        <div className="p-6 bg-white shadow-md w-full lg:w-1/3">
          <h2 className="text-lg font-bold bg-[#784421] text-white px-4 py-3">
            Cart Total
          </h2>
          <div className="bg-gray-50 p-6">
            <div className="flex justify-between py-2 text-lg">
              <span>Subtotal</span>
              <span>₹{totals.subtotal}</span>
            </div>
            <div className="flex justify-between py-2 text-lg">
              <span>GST (3%)</span>
              <span>₹{totals.tax}</span>
            </div>
            <div className="flex justify-between py-2 text-lg">
              <span>Shipping</span>
              <span>₹{totals.shipping}</span>
            </div>
            <div className="flex justify-between py-2 text-lg text-green-600">
              <span>Discount</span>
              <span>₹{totals.discount}</span>
            </div>
            <div className="border-t mt-6 pt-4 flex justify-between font-bold text-xl">
              <span>Total</span>
              <span>₹{totals.total}</span>
            </div>
          </div>
          <Link to="/checkout">
            <button className="bg-[#D87F30] text-white px-6 py-3 w-full mt-4 hover:bg-[#b56322] transition-colors">
              PROCEED TO CHECKOUT
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ShoppingCart;